module.exports = __webpack_public_path__ + "img/9788949190020.be05cfb4.jpg";